/**
 * @module types/settings/freeze
 * @description 表格冻结窗格配置项领域模型（存储字段名 `freeze`）
 */

/** 表格冻结窗格配置（与 FreezePanes 上传字段一致） */
export interface IFreezeSetting {
  show: boolean;
  count: number;
}

/** 缺省形态：关闭冻结，列数为 1（开启时由 UI clamp 到 [1, 5]） */
export const FREEZE_DEFAULT: IFreezeSetting = { show: false, count: 1 };
